export default __webpack_public_path__ + "static/media/pokerFace.6361aa23.svg";